import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEducation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEducation"><Path d="M22 16H20.9268C20.5299 16.9818 20.5337 18.0138 20.9268 19H22V21H5.5C3.567 21 2 19.433 2 17.5C2 15.567 3.567 14 5.5 14H22V16Z" fill="currentColor"/><Path d="M14.1367 2.88672C13.6306 3.39283 13.3153 3.77822 13.1299 4.12012C20.3338 2.60635 18.4593 15.8348 11.999 12.8535C5.44632 15.8779 3.61297 2.21897 11.1895 4.19727C11.4133 3.21942 12.041 2.43555 12.8633 1.61328L14.1367 2.88672Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEducation;
